"use client";

import { getAnalytics } from "../analytics-runtime";
import type { AutoTrackingOptions } from "../auto-tracking";
import { useAutoTracking } from "./use-auto-tracking";

export function AnalyticsAutoTracker({ options }: { options: AutoTrackingOptions }): null {
	useAutoTracking({ ...options, getAnalytics });
	return null;
}
